<template>
    <div>
    </div>
</template>

<script>
    import Network from "../../vue-components/helpers/Network";

    export default {
        name: `email-activation`,
        data() {
            return {

            }
        },
        activated() {
            Network.post(`/wifi/client/user/send-verification`)
                .then(() => {
                    this.$swal({
                        title: this.tr(`A verification email has been sent to you|Un courriel de vérification vous a été envoyé`),
                        icon: `info`
                    }).finally(() => {
                        this.reach(`/dashboard`);
                    });
                });
        }
    }
</script>

<style lang="scss" scoped>

</style>
